import React, { Component } from "react";
import {
  Dimensions,
  Image,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  Platform,
  PermissionsAndroid,
} from "react-native";
import AutoHeightImage from "react-native-auto-height-image";
import { connect } from "react-redux";
import DoctorDetailMore from "../components/DoctorDetailMore";
import { getBaseUrl } from "../helpers/storage";
import font from "../constants/fonts";
import staticColors from "../constants/staticColors";

const { width } = Dimensions.get("window");

const styles = StyleSheet.create({
  name: {
    ...font.bold,
    fontSize: 20,
    paddingHorizontal: 35,
    color: "#FFF"
  },
  position: {
    ...font.regular,
    fontSize: 16,
    paddingHorizontal: 35,
    color: "#FFF"
  },
  actionsContainer: {
    padding: 25,
    flexDirection: "row",
    justifyContent: "center",
    borderColor: "#F1F1F1",
    borderBottomWidth: 1
  },
  container: {
    backgroundColor: "#FFF",
    borderTopEndRadius: 40,
    borderTopStartRadius: 40,
    flex: 1,
    width: width,
    marginTop: -40
  },
  action: {
    height: 50,
    width: 50,
    borderRadius: 50,
    marginHorizontal: 10,
    alignItems: "center",
    justifyContent: "center"
  }
});

class DoctorProfileScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      avatarUrl: "https://izi.medlinx.id/uploads/userfiles/test.png",
      fullName: "",
      specialities: "",
      str: "",
      sip: "",
      education: "",
      hospitalName: "",
      hospitalAdress: "-"
    };
  }

  componentDidMount() {
    const token = this.props.token;

    fetch(
      getBaseUrl() +
        "consultations/doctor-info?trx_id=" +
        this.props.navigation.state.params.transactionId,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      }
    )
      .then(res => res.json())
      .then(json => {
        this.setState({
          avatarUrl: json["data"]["doctor_photo"],
          fullName:
            json["data"]["doctor_f_name"] + " " + json["data"]["doctor_l_name"],
          specialities: json["data"]["speciality_name"].join(", "),
          str: json["data"]["doctor_str"],
          sip: json["data"]["doctor_sip"],
          education: json["data"]["doctor_education"],
          hospitalName: json["data"]["hospital_name"],
          hospitalAdress: json["data"]["doctor_address"]
        });
      });
  }

  checkPermissionAndLaunchAudio = () => {
    const { hasViId, enableVoiceCall } = this.props.navigation.state.params;
    
    if(hasViId && enableVoiceCall) {
      if (Platform.OS === "android") {
        let permissions = [PermissionsAndroid.PERMISSIONS.RECORD_AUDIO];

        PermissionsAndroid.requestMultiple(permissions).then(
          granted => {
            const recordAudioGranted =
              granted["android.permission.RECORD_AUDIO"] ===
              "granted";

            if (recordAudioGranted) {
              this.goToAudioCallScreen()
            }
          }
        );
      } else {
        this.goToAudioCallScreen()
      }
    }
  }

  checkPermissionAndLaunchVideo = () => {
    const { hasViId, enableVideoCall } = this.props.navigation.state.params;
    
    if(hasViId && enableVideoCall) {
      if (Platform.OS === "android") {
        let permissions = [
          PermissionsAndroid.PERMISSIONS.CAMERA,
          PermissionsAndroid.PERMISSIONS.RECORD_AUDIO,
        ];
  
        PermissionsAndroid.requestMultiple(permissions).then(granted => {
          const cameraGranted =
            granted["android.permission.CAMERA"] ===
                "granted";
            const recordAudioGranted =
              granted["android.permission.RECORD_AUDIO"] ===
              "granted";
  
            if (cameraGranted && recordAudioGranted) {
              this.goToVideoCallScreen()
            }
          }
        );
      } else {
        this.goToVideoCallScreen()
      }
    }
  }

  navigateCall = (callType) => {
    const { navigation } = this.props;

    navigation.navigate(callType, {
      doctor: {
        fullName: navigation.state.params.doctorFullname,
      },
      patient: {
        id: navigation.state.params.patientId,
      },
      transaction: {
        id: navigation.state.params.transactionId,
      }
    });
  }

  goToVideoCallScreen = () => {
    this.navigateCall("VideoCall");
  }

  goToAudioCallScreen = () => {
    this.navigateCall("AudioCall");
  }

  render() {
    const { hasViId, enableVoiceCall, enableVideoCall } = this.props.navigation.state.params;
    return (
      <ScrollView style={{ flex: 1 }}>
        <View>
          <AutoHeightImage
            source={{ uri: this.state.avatarUrl }}
            width={width}
          />

          <View
            style={{
              bottom: 0,
              position: "absolute",
              paddingBottom: 50,
              paddingVertical: 10,
              backgroundColor: this.props.themeColors.primary,
              borderTopEndRadius: 40,
              borderTopStartRadius: 40,
              left: 0,
              right: 0
            }}
          >
            <Text style={styles.name}>{this.state.fullName}</Text>
            <Text style={styles.position}>{this.state.education}</Text>
          </View>
        </View>

        <View>
          <View style={styles.container}>
            <View style={styles.actionsContainer}>
              <TouchableOpacity onPress={() => this.props.navigation.goBack()}>
                <View
                  style={[
                    styles.action,
                    {
                      backgroundColor: this.props.themeColors.primary
                    }
                  ]}
                >
                  <Image
                    source={require("../assets/round_chat_bubble_white_18dp.png")}
                    style={{ height: 24, width: 24 }}
                  />
                </View>
              </TouchableOpacity>
              <TouchableOpacity onPress={this.checkPermissionAndLaunchVideo}>
                <View
                  style={[
                    styles.action, hasViId && enableVideoCall ? 
                    {
                      backgroundColor: this.props.themeColors.primary
                    } : 
                    {
                      backgroundColor: staticColors.grey
                    }
                  ]}
                >
                  <Image
                    source={require("../assets/round_videocam_white_18dp.png")}
                    style={{ height: 28, width: 28 }}
                  />
                </View>
              </TouchableOpacity>
              <TouchableOpacity onPress={this.checkPermissionAndLaunchAudio}>
                <View
                  style={[
                    styles.action, hasViId && enableVoiceCall ?
                    {
                      backgroundColor: this.props.themeColors.primary
                    } :
                    {
                      backgroundColor: staticColors.grey
                    }
                  ]}
                >
                  <Image
                    source={require("../assets/round_call_white_18dp.png")}
                    style={{ height: 26, width: 26 }}
                  />
                </View>
              </TouchableOpacity>
            </View>
            <DoctorDetailMore
              education={this.state.education}
              hospital={this.state.hospitalName}
              practiceLicense={this.state.sip}
              registrationCertificate={this.state.str}
            />
          </View>
        </View>
      </ScrollView>
    );
  }
}

export default connect(state => ({
  themeColors: state.themeColors,
  token: state.token
}))(DoctorProfileScreen);
